'use strict';

module.exports = require('./is-implemented')()
	? Object.keys
	: require('./shim');



/*****************
 ** WEBPACK FOOTER
 ** ./~/event-emitter/~/es5-ext/object/keys/index.js
 ** module id = 10
 ** module chunks = 0
 **/